// extracted by mini-css-extract-plugin
export default {"icon":"main-menu-icon_icon__FXM47"};